'use client';

import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Copy, ShareIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

import { FacebookShareButton, FacebookIcon } from 'next-share';
import { FacebookMessengerShareButton, FacebookMessengerIcon } from 'next-share';
import { TwitterShareButton, TwitterIcon } from 'next-share';
import { WhatsappShareButton, WhatsappIcon } from 'next-share';
import { useToast } from '@/components/ui/use-toast';

export default function ShareButton({ title }: { title: string }) {
  let url = '';
  if (typeof window !== 'undefined') {
    url = window.location.href;
  }
  const { toast } = useToast();

  const copyToClipboard = (str: string) => () => {
    navigator.clipboard.writeText(str);
    toast({
      title: 'Text copied to clipboard',
    });
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="gap-1 underline rounded-md underline-offset-2 justify-end font-normal"
        >
          <ShareIcon className="w-4 h-4" />
          Share
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Share this place</DialogTitle>
          <DialogDescription>
            <div className="flex gap-2 mt-6 items-center">
              {/* <CopyIcon className="w-8 h-8 rounded-lg" /> */}

              <FacebookShareButton url={url} quote={title} hashtag={'#nextshare'}>
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <FacebookMessengerShareButton url={url} appId={''}>
                <FacebookMessengerIcon size={32} round />
              </FacebookMessengerShareButton>
              <TwitterShareButton url={url} title={title}>
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <WhatsappShareButton url={url} title={title} separator=":: ">
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
              <Copy onClick={copyToClipboard(url)}></Copy>
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
